// extracted by mini-css-extract-plugin
export default {"text":"wall_text__9eKlC","word":"wall_word__IEkCk","highlight":"wall_highlight__dMz3C"};